
import Vertical from "./vertical-layout.vue";

export default {
  components: {
    Vertical,
  },
};
